import { apiActionTypes } from '../../middleware';
const base = '@@Containers/App/';

export const GET_CURRENT_CURRENCY = apiActionTypes(`${base}GET_CURRENT_CURRENCY`);

export const SET_CURRENT_CURRENCY = apiActionTypes(`${base}SET_CURRENT_CURRENCY`);

export const GET_CURRENCY_CONVERSION = apiActionTypes(`${base}GET_CURRENCY_CONVERSION`);
